import React, {Component , PropTypes} from 'react'
import {Map} from 'immutable'
import ActionCreators from 'actions/ActionCreators'
import {
    TYPE_FLEXIBLE_DATE_WITH_DRIVER,
    TYPE_FIXED_DATE_WITH_DRIVER,
    TYPE_FIXED_DATE_WITH_LOADERS,
} from '../../constants/Instantprices'
import {toMoneyFormat} from '../../../tools/number'
import ga from 'react-ga'
import './Options.scss'
import {format} from "date-fns";
import ru from "date-fns/locale/ru";
import {capitalize} from "lodash";

class BookingTime extends Component {
    
    static propTypes = {
        day: PropTypes.instanceOf(Map),
        dates: PropTypes.object,
        selectedPartDay: PropTypes.instanceOf(Map),
        type: PropTypes.number,
        selectedCategory: PropTypes.object,
    }
    
    state = {
        openTime: false,
    }

    componentWillMount() {
        document.addEventListener('click', this.handleTimeClickOutside, false);
    }

    componentWillUnmount(){
        document.removeEventListener('click', this.handleTimeClickOutside, false);
    }

    handleTimeClick = () => {
        this.setState({
            openTime: !this.state.openTime,
        })
    }

    handleTimeClickOutside = (event) => {
        if (!this.refs.BookingTimeSelect.contains(event.target)) {
            this.setState({
                openTime: false,
            })
        }
    }

    onChangeTime = (time, event) => {
        event.preventDefault()

        const selectedPartDay = Map(time)
        
        ActionCreators.selectInstantBookingPartDay(selectedPartDay)
        ActionCreators.calculateInstantBookingPrice()

        ga.event({
            category: 'clicks',
            action: `change_time_instant_booking_${selectedPartDay.keySeq().get(0)}`,
            label: this.props.selectedCategory.name,
            value: 1,
        })

        this.handleTimeClick();
    }
    
    getPrice = (time, desc) => {
        switch (this.props.type) {
            case TYPE_FLEXIBLE_DATE_WITH_DRIVER:
                return this.props.day.get('date_desc').flex_price
                break
            case TYPE_FIXED_DATE_WITH_LOADERS:
            case TYPE_FIXED_DATE_WITH_DRIVER:
                // if (this.props.selectedPartDay.size > 0 && desc !== this.props.selectedPartDay.keySeq().get(0)) {
                if (this.props.selectedPartDay.size > 0) {
                    const selectedPrice = this.props.selectedPartDay.valueSeq().get(0).price
                    const diff = toMoneyFormat(Math.abs(selectedPrice - time.price))
                    
                    let prefix = ''
                    if (selectedPrice > time.price) {
                        prefix = '-'
                    }
                    
                    if (selectedPrice <= time.price) {
                        prefix = '+'
                    }
                    
                    return prefix + diff
                }

                return toMoneyFormat(time.price)
                break
            default:
                return toMoneyFormat(time.price)
        }
    }

    renderTotalTitle = () => {
        let finalDateParts = []

        if (this.props.dates.from) {
            finalDateParts.push(format(this.props.dates.from, 'DD MMMM', {locale: ru}))
        }

        if (this.props.dates.to && this.props.dates.from !== this.props.dates.to) {
            finalDateParts.push(format(this.props.dates.to, 'DD MMMM', {locale: ru}))
        }

        return (
            <span>{capitalize(finalDateParts.join('–'))}</span>
        )
    };

    renderSelectPlaceholder = (desc, timeStart, timeEnd, price) => {
        if (this.props.selectedPartDay.size > 0) {
            let result = [];
            desc ? result.push(<span key={0}>{desc}</span>) : null;
            (timeStart && timeEnd) && (timeStart !== timeEnd) ? result.push(<span key={1}>c <b>{timeStart}</b> до <b>{timeEnd}</b></span>) : null;
            price ? result.push(<span key={2}><b>{toMoneyFormat(price)}₽</b></span>): null;
            return result;
        } else {
            return 'Выберите время погрузки'
        }
    };

    timeFromString = (str) => {
        if (!str) {
            return false;
        }

        let result = [];

        const timeStartIndex = str.indexOf(':');
        const timeEndIndex = str.lastIndexOf(':');

        if ((!timeStartIndex && !timeEndIndex) && timeStartIndex === timeEndIndex) {
            return false;
        }

        const timeStart = str.slice(timeStartIndex-2, timeStartIndex+3);
        const timeEnd = str.slice(timeEndIndex-2, timeEndIndex+3);

        result.push(timeStart);
        result.push(timeEnd);

        return result;
    }

    render() {
        if (this.props.day.size === 0) {
            return null
        }

        // const selectedPartDayDesc = this.props.selectedPartDay.size > 0 ? this.props.selectedPartDay.keySeq().get(0) : '';

        const selectedTime = this.props.selectedPartDay;
        let desc = '';
        let timeStart = '';
        let timeEnd = '';
        let price = 0;

        if (selectedTime.size > 0) {
            desc = selectedTime.keySeq().get(0);
            timeStart = format(selectedTime.valueSeq().get(0).dt_start, 'HH:mm', {locale: ru});
            timeEnd = format(selectedTime.valueSeq().get(0).dt_end, 'HH:mm', {locale: ru});
            price = selectedTime.valueSeq().get(0).price;
            if (desc) {
                const timeFromString = this.timeFromString(desc);

                if (timeFromString) {
                    if (timeFromString[0] === timeStart && timeFromString[1] === timeEnd){
                        desc = undefined;
                    }
                }
            }
        }

        return (
            <div className="Options">
                <div className="Options-changing">
                    {/*<div className="Options-dateOfCarriage">Перевозка <b>{this.renderTotalTitle()}</b></div>*/}
                        {/*<div className="Options-changingLabel">
                            {
                                this.state.openTime ?
                                    'Укажите удобное для вас время' : (
                                        <div className="Options-changingLabelTime">
                                            {selectedPartDayDesc} &nbsp;
                                            <ButtonControl view="blueLink"
                                                           size="s"
                                                           onClick={this.toggleTime}>
                                                поменять
                                            </ButtonControl>
                                        </div>
                                    )
                            }
                        </div>*/}
                        {/*<div>Мы позвоним вам заранее до приезда машины</div>*/}
                        {/*<AnimakitExpander duration={100} expanded={this.state.openTime}>
                            {this.props.day.get('part_day').map(time => {
                                const desc = Object.keys(time)[0]
                                const priceData = Object.values(time)[0]
                                const price = this.getPrice(priceData, desc)

                                return (
                                    <div key={desc} className="Options-valueBar">
                                        <div>{desc}</div>
                                        <div className="Options-value">
                                            <div className="Options-valueLabel">{price}₽</div>
                                            <RadioControl
                                                name="time"
                                                label=""
                                                value={String(price)}
                                                checked={selectedPartDayDesc === desc}
                                                onChange={this.onChangeTime.bind(this, time)}/>
                                        </div>
                                    </div>
                                )
                            })}
                            <ButtonControl
                                className="Options-saveTimeButton"
                                view="blueLink"
                                size="s"
                                onClick={this.toggleTime}>
                                OK
                            </ButtonControl>
                        </AnimakitExpander>*/}

                        <div className="dateOfCarriage">
                            Перевозка <b>{this.renderTotalTitle()}{(timeStart && timeEnd) && (timeStart !== timeEnd) ? <span>, c {timeStart} до {timeEnd}</span> : desc ? <span>, {desc}</span> : null}</b>
                        </div>
                        <div>Время подачи машины на погрузку</div>
                        <div className="BookingTimeSelect" ref="BookingTimeSelect">
                            <div className="BookingTimeSelect-header" onClick={() => this.handleTimeClick()}>
                                <div className="BookingTimeSelect-placeholder">
                                    {this.renderSelectPlaceholder(desc, timeStart, timeEnd, price)}
                                </div>
                            </div>
                            {this.state.openTime && <ul className="BookingTimeSelect-list">
                                {this.props.day.get('part_day').map( (time, index) => {
                                    let desc = Object.keys(time)[0];
                                    const priceData = Object.values(time)[0];
                                    const timeStart = format(priceData.dt_start, 'HH:mm', {locale: ru});
                                    const timeEnd = format(priceData.dt_end, 'HH:mm', {locale: ru});
                                    const price = this.getPrice(priceData, desc);

                                    if (desc) {
                                        const timeFromString = this.timeFromString(desc);

                                        if (timeFromString) {
                                            if (timeFromString[0] === timeStart && timeFromString[1] === timeEnd){
                                                desc = undefined;
                                            }
                                        }
                                    }

                                    return (<li className="BookingTimeSelect-list-item" key={index} onClick={this.onChangeTime.bind(this, time)}>
                                        {desc && <span>{desc}</span>}
                                        {(timeStart && timeEnd) && (timeStart !== timeEnd) && <span>c <b>{timeStart}</b> по <b>{timeEnd}</b></span>}
                                        {price && <span><b>{price}₽</b></span>}
                                    </li>)
                                })}
                            </ul>}
                        </div>
                </div>
            </div>
        )
    }
}

export default BookingTime



// WEBPACK FOOTER //
// ./client/components/InstantBookingScreen/BookingTime.js